import { moduleState } from 'cerebral'
import { crudActions } from '../factories'

export const { find, setList, clearList, get, save, remove } = crudActions({ name: 'mealLocations' })

export const changeMealLocation = ({ props: { location = null }, store }) => {
  store.set(moduleState`currentLocation`, location)
}
